import { render, staticRenderFns } from "./FoodBrandList.vue?vue&type=template&id=0731ace6&"
import script from "./FoodBrandList.vue?vue&type=script&lang=js&"
export * from "./FoodBrandList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports